import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BenefitCategoryData {
    benefitsCategory: {};
}

const benefitCategorySlice = createSlice({
    name: "benefitCategory",
    initialState: { benefitCategoryData: {} },
    reducers: {
        setBenefitCategoryData: (state, action: PayloadAction<BenefitCategoryData>) => {
            state.benefitCategoryData = action.payload;
        },
    },
});

const { reducer, actions } = benefitCategorySlice;

export const {
    setBenefitCategoryData
  } = actions;

export const benefitCategories = reducer;
